import { gql } from "@apollo/client";
export const UPDATE_OBJECTIVES_BY_USER_ID = gql`
  mutation UpdateObjectivesByUserId($user_id: uuid!, $description: String!) {
    delete_objectives(where: { user_id: { _eq: $user_id } }) {
      affected_rows
    }
    insert_objectives(
      objects: { user_id: $user_id, description: $description }
    ) {
      affected_rows
      returning {
        user_id
        description
      }
    }
  }
`;

export const UPDATE_COSTS_BY_USER_ID = gql`
  mutation InsertCostsAndDeletePrevious(
    $user_id: uuid!
    $costs: [costs_insert_input!]!
  ) {
    delete_costs(where: { user_id: { _eq: $user_id } }) {
      affected_rows
    }
    insert_costs(objects: $costs) {
      affected_rows
      returning {
        id
        cost_per_year
        number_of_years
        category
        description
        total_cost
        is_ongoing
        costs_per_month
      }
    }
  }
`;

export const UPDATE_QUANTITATIVE_BENEFITS_BY_USER_ID = gql`
  mutation InsertBenefitsAndDeletePrevious(
    $user_id: uuid!
    $benefits: [benefits_insert_input!]!
  ) {
    delete_benefits(where: { user_id: { _eq: $user_id } }) {
      affected_rows
    }
    insert_benefits(objects: $benefits) {
      affected_rows
      returning {
        id
        benefit_per_year
        number_of_years
        category
        description
        total_benefit
        is_ongoing
        benefits_per_month
        user_id
      }
    }
  }
`;

export const UPDATE_QUALITATIVE_BENEFITS_BY_USER_ID = gql`
  mutation InsertQualitativeBenefitsAndDeletePrevious(
    $user_id: uuid!
    $qualitative_benefits: [qualitative_benefits_insert_input!]!
  ) {
    delete_qualitative_benefits(where: { user_id: { _eq: $user_id } }) {
      affected_rows
    }
    insert_qualitative_benefits(objects: $qualitative_benefits) {
      affected_rows
      returning {
        user_id
        category
        benefits
      }
    }
  }
`;

export const UPDATE_ASSUMPTIONS_BY_USER_ID = gql`
  mutation InsertAssumptions(
    $internalHurdleRate: numeric
    $description: String
    $user_id: uuid!
  ) {
    delete_assumptions(where: { user_id: { _eq: $user_id } }) {
      affected_rows
    }
    insert_assumptions(
      objects: {
        internalHurdleRate: $internalHurdleRate
        description: $description
        user_id: $user_id
      }
    ) {
      affected_rows
      returning {
        internalHurdleRate
        description
        user_id
      }
    }
  }
`;

export const CREATE_SUMMARY_MUTATION = gql`
  mutation insert_summaries(
    $summary: [summaries_insert_input!]!
    $user_id: uuid!
  ) {
    delete_summaries(where: { user_id: { _eq: $user_id } }) {
      affected_rows
    }
    insert_summaries(objects: $summary) {
      returning {
        user_id
        netCashFlow
        discountedCashFlow
        annualIhr
        monthlyIhr
        annualIrr
        monthlyIrr
        annualCumulativeCashFlow
        monthlyCumulativeCashFlow
        totalCost
        totalBenefit
        payBackPeriod
        roi
        roiValid
        maxYears
        netProfit
        netProfitArray
        discountedNbArraySum
        totalCostArray
        totalBenefitArray
        netProfit
        netPresentValue
        irrValid
        discountedNbArray
      }
    }
  }
`;
